var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c(
        "app-section",
        [_c("app-title", [_vm._v(_vm._s(_vm.$ct("title-no-dossiers")))])],
        1
      ),
      _c(
        "app-section",
        [_c("app-text", [_vm._v(_vm._s(_vm.$ct("text-no-dossiers")))])],
        1
      ),
      _c(
        "app-section",
        [
          _c(
            "app-text",
            [
              _c("w-link", { attrs: { to: "/login" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("back-to-login")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }